import { iconFor } from "../lib/icons";

// T57: homepage highlights strip (Admin > Content > Homepage highlights). Phone: stacked list, icon left.
// 641-1023px: 2x2 grid. 1024px+: 4 columns. Dividers are short, centred and very low contrast.
export function HomeHighlights({ items, testid = "home-highlights" }) {
  if (!items?.length) return null;
  return (
    <section aria-label="Why buy from Rhyte Step IT" data-testid={testid}
      className="my-10 rounded-2xl border border-slate-200/70 bg-white px-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] min-[641px]:px-2 lg:px-0">
      <ul className="grid grid-cols-1 min-[641px]:grid-cols-2 lg:grid-cols-4">
        {items.map((h, i) => {
          const Icon = iconFor(h.icon);
          const v = `${i % 2 === 1 ? "min-[641px]:block" : "min-[641px]:hidden"} ${i % 4 !== 0 ? "lg:block" : "lg:hidden"}`;
          const hz = `${i > 0 ? "block" : "hidden"} ${i >= 2 ? "min-[641px]:block" : "min-[641px]:hidden"} ${i >= 4 ? "lg:block" : "lg:hidden"}`;
          return (
            <li key={i} className="relative flex items-center gap-4 py-5 min-[641px]:px-8 min-[641px]:py-7 lg:gap-3 lg:px-2 lg:py-8 xl:gap-3.5 xl:px-3.5" data-testid={`${testid}-item-${i}`}>
              <span aria-hidden="true" className={`absolute left-0 top-1/2 hidden h-[64%] w-px -translate-y-1/2 bg-slate-200/70 ${v}`} data-testid={`${testid}-vdiv-${i}`} />
              <span aria-hidden="true" className={`absolute left-0 right-0 top-0 h-px bg-slate-200/70 min-[641px]:left-[10%] min-[641px]:right-[10%] ${hz}`} data-testid={`${testid}-hdiv-${i}`} />
              <Icon aria-hidden="true" focusable="false" strokeWidth={1.75} data-testid={`${testid}-icon-${i}`}
                className="h-9 w-9 shrink-0 text-[var(--brand-accent)] min-[641px]:h-10 min-[641px]:w-10 lg:h-10 lg:w-10 xl:h-11 xl:w-11" />
              <div className="min-w-0">
                <h3 className="text-[15px] font-semibold leading-snug text-[var(--brand-primary)] [text-wrap:balance] xl:text-base" data-testid={`${testid}-title-${i}`}>{h.title}</h3>
                <p className="mt-0.5 text-sm leading-snug text-slate-500 [text-wrap:balance]" data-testid={`${testid}-sub-${i}`}>{h.sub}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
